import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import "./index.scss"

export default function NarrativeTextBlock({ component }) {
  const {
    hasImage,
    blockImage,
    textContent,
    blockWidth,
    highlightColor,
    imageAlignment,
  } = component

  const img = getImage(blockImage[0].featuredImage)

  return (
    <div
      className={`narrative-text-block ${
        hasImage && "has-image"
      } ${highlightColor}`}
    >
      <div className="container">
        {
          <div
            className={`row ${
              hasImage === true && imageAlignment === "left"
                ? "row-reverse"
                : ""
            }`}
          >
            {hasImage ? (
              <>
                <div
                  className="col-md-6"
                  dangerouslySetInnerHTML={{ __html: textContent }}
                ></div>
                <div className="col-md-5">
                  <div className="block-img">
                    <GatsbyImage
                      image={img}
                      alt="image"
                      className="narrative-text-block__image"
                    />
                    {blockImage[0]?.featuredImage?.title && (
                      <div className="img-overlay">
                        {blockImage[0]?.featuredImage?.title}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-1"></div>
              </>
            ) : (
              <div
                className={`col-md-${blockWidth}`}
                dangerouslySetInnerHTML={{ __html: textContent }}
              ></div>
            )}
          </div>
        }
      </div>
    </div>
  )
}
